var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMore(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "current",
    height: "current",
    viewBox: "0 0 6 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.07595 8.15644C4.27632 8.15644 5.23662 9.13205 5.23662 10.3516C5.23662 11.5711 4.27632 12.5467 3.07595 12.5467C1.87558 12.5467 0.915283 11.5711 0.915283 10.3516C0.915283 9.13205 1.87558 8.15644 3.07595 8.15644ZM0.915283 2.54668C0.915283 3.7662 1.87558 4.74181 3.07595 4.74181C4.27632 4.74181 5.23662 3.7662 5.23662 2.54668C5.23662 1.32717 4.27632 0.351563 3.07595 0.351562C1.87558 0.351562 0.915283 1.32717 0.915283 2.54668ZM0.915283 18.1564C0.915283 19.376 1.87558 20.3516 3.07595 20.3516C4.27632 20.3516 5.23662 19.376 5.23662 18.1564C5.23662 16.9369 4.27632 15.9613 3.07595 15.9613C1.87558 15.9613 0.915283 16.9369 0.915283 18.1564Z",
    fill: "current"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMore);
export default __webpack_public_path__ + "static/media/more.6de4631b9c0b7e75a3baf98b75498d63.svg";
export { ForwardRef as ReactComponent };